// App.js
import React from 'react';
import './App.css';
import Screen from './components/Screen';

const App = () => {
  // Configuration for screens
  const screens = [
    {
      images: [    
        { url: 'images/PrestigeNewJazz.png', title: 'Prestige New Jazz', className: 'large-image hide-mobile' }
      ],
      texts: [
        { content: 
          <>
          <p className="title-text">Styling Jazz</p>
          </>, top: 0, left: 0},
        { content: 'The Cover Art of Prestige Records', top: 15, left: 0},
        { content: <a href="#about-section">About the project</a>, top: 20, left: 0},
        { content: 
          
        <>
        <p>Founded in 1949, Prestige Records came onto the scene at a turning point for jazz music and the recording industry as a whole.</p>
        <p>Until only recently, record companies had been in dire straits. The Depression meant far fewer Americans could afford going out and buying new records. Times were so desperate that some were forced to burn old phonograph records just to keep warm.</p>
        <p>Labels needed new ways to market and sell their inventory. In the late 1930s, they started to transform the nondescript wrappers around records to be more visually eye-catching.</p>
        <p>But it wasn’t until after World War II, when the US had replenished its supply of materials like shellac and vinyl, that the record industry — and the album cover as an art form — exploded in popularity.</p>
        </>, top: 35, left: 10, style: {
          width: '50%'
          } }      
      ]
    },
    {
      images: [
        { url: 'images/KonitzTristano.jpg', title: 'Konitz Tristano' },
        { url: 'images/KonitzGetz.jpg', title: 'Konitz Getz' },
        { url: 'images/Mulligan.jpg', title: 'Mulligan' },
        { url: 'images/DavisNewSounds.jpg', title: 'Davis New Sounds' },
        { url: 'images/DavisBlue.jpg', title: 'Davis Blue' }   
      ],
      texts: [
        { content: <>
          <p>As a small, independent label, Prestige had a fraction of the budget of a conglomerate like Columbia Records, and in the early days it showed.</p>
          <p>The cover designs for its earliest releases — 10" LPs for artists like Lee Konitz, Lennie Tristano, Stan Getz, and Gerry Mulligan — were stark in color and design, and they typically used label head Bob Weinstock's own photographs from recording sessions.</p>
          <p>In 1951, he signed Miles Davis, a rising trumpet star who was then just a couple years into being a bandleader.</p>
          <p>The first releases with Miles are similarly pared-down, even using the same photograph across releases.</p>
          </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/Davis4.jpg', title: 'Alt text tk' },
        { url: 'images/Davis6.jpg', title: 'Alt text tk' },
        { url: 'images/DavisQuintetSextet.jpeg', title: 'Alt text tk' },
        { url: 'images/DavisDig.jpeg', title: 'Alt text tk' },
        { url: 'images/Davis15.jpg', title: 'Alt text tk' },
        { url: 'images/Davis16.jpg', title: 'Alt text tk' },
        { url: 'images/Davis18.jpg', title: 'Alt text tk' },
        { url: 'images/Davis21.jpg', title: 'Alt text tk' },
        { url: 'images/Davis22.jpg', title: 'Alt text tk' }
      ],
      texts: [
        { content: <>
        <p>But as Miles’ star rose higher and higher, the album covers start to become more curated, helping to craft a unique image of the artist.</p>
        <p>Miles Davis would become a top-selling artist for Prestige, gracing more album covers than any other artist over the next decade. As Bob Weinstock once said, Miles made “my company world-famous.”</p>
        <p>Davis often appeared alone in a relaxed setting, trumpet or cigarette in hand, helping to define his “cool” aesthetic.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/MilesDavisKindofBlue.jpg', title: 'Alt text tk', className: 'large-image' }
      ],
      texts: [
        { content: <>
        <p>Davis finished his contract with Prestige and left for Columbia in the mid-1950s, and he’d go on to record his biggest albums (like <em>Kind of Blue</em>) there.</p>
        <p>This trajectory wasn’t unique to Davis. Prestige often sought out up-and-coming artists and helped them make a name for themselves — though often with little pay — before they graduated to bigger recording contracts elsewhere.</p>
        <p>The album cover designs played a crucial role in shaping the identities of Prestige's roster of musicians.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/RollinsMonk.jpg', title: 'Alt text tk' },
        { url: 'images/McLean456.jpeg', title: 'Alt text tk' },
        { url: 'images/Green.jpg', title: 'Alt text tk' },
        { url: 'images/Monk.jpg', title: 'Alt text tk' }
      ],
      texts: [
        { content: <>
        <p>Early on, Weinstock primarily marketed the authenticity of his players. He limited the time available for rehearsal prior to recording, both as a cost-cutting measure and as a way to tap into a more spontaneous, live feel. His photos for the early covers speak to this ethos.</p>
        <p>But as Prestige grew, Weinstock outsourced the role of cover photography and design to a range of artists with their own sensibilities. This cast of designers would expand Prestige’s visual vocabulary.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/MJQYoung.jpg', title: 'Alt text tk' },
        { url: 'images/Davis3.jpg', title: 'Alt text tk' },
        { url: 'images/Raney.jpg', title: 'Alt text tk' },
        { url: 'images/FarmerYoung.jpg', title: 'Alt text tk' },
        { url: 'images/Charles.jpg', title: 'Alt text tk' },
        { url: 'images/FarmerYoung2.jpg', title: 'Alt text tk' }
      ],
      texts: [
        { content: <>
        <p>Designing record covers was an envious role, even for fine artists.</p>
        <p>One of the first hires was an emerging New York artist named David X. Young, a painter whose loft on 6th Ave. in Manhattan became famous for its all-night jazz sessions.</p>
        <p>Young's covers took Prestige's art in more modern and abstract directions, suggesting a loose, layered sound.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/TromboneByThreeWarhol.jpg', title: 'Alt text tk' },
        { url: 'images/WarholMilesMonk.jpeg', title: 'Alt text tk' },
        { url: 'images/MoondogWarhol.jpeg', title: 'Alt text tk' }
      ],
      texts: [
        { content: <>
        <p>Another artist on Prestige's payroll in the mid-1950s was none other than Andy Warhol, who was just starting to develop a reputation as a solo artist.</p>
        <p>Some of his covers featured whimsical line drawings; others incorporated the handwriting of his mother, Julia Warhola.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/DavisHorns.jpg', title: 'Alt text tk' },
        { url: 'images/FarmerMartin.jpg', title: 'Alt text tk' },
        { url: 'images/StittMartin.jpeg', title: 'Alt text tk' },
        { url: 'images/GetzMartin.jpg', title: 'Alt text tk' },
        { url: 'images/TromboneByThreeMartin.jpg', title: 'Alt text tk' }
      ],
      texts: [
        { content: <>
        <p>Some of the most amusing covers came from Don Martin, a cartoonist who would later become one of Mad Magazine's most popular artists.</p>
        <p>However, while these designers expanded the boundaries of album cover art, their illustrations were the minority. As a whole, illustrations and graphic layouts represent around 20% of Prestige’s covers from this era.</p>
        <p>The rest are dominated by photography, which was gaining prominence not only as a mass-market medium, but as an expressive art form.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/Bryant.jpg', title: 'Alt text tk' },
        { url: 'images/ColtraneEdwards.jpg', title: 'Alt text tk' },
        { url: 'images/Davis21.jpg', title: 'Alt text tk' },
        { url: 'images/Garland.jpg', title: 'Alt text tk' },
        { url: 'images/Coltrane2.jpg', title: 'Alt text tk' },
        { url: 'images/alexanderPleasure.jpg', title: 'Alt text tk' },
        { url: 'images/Woods.jpg', title: 'Alt text tk' },
        { url: 'images/Dorham.jpg', title: 'Alt text tk' }
      ],
      texts: [
        { content: <>
        <p>From 1951 to 1964, four in 5 Prestige covers featured photographs.</p>
        <p>The most common shot is of the primary musician in the ensemble looking contemplative, serious, intense. These are mood shots — the musicians rarely crack a smile.</p>
        <p>The artists themselves had little say in the cover designs. That typically fell to the label, and their design choices often tied back to what would sell the most records.</p>
        <p>This moody style of photography emphasized players' individualism, pushing the highly marketable trait of genius — a way for labels to differentiate the current strain of jazz from the big-band era that preceded it.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/McintyreDolphy.jpg', title: 'Alt text tk' },
        { url: 'images/McLeanCo.jpg', title: 'Alt text tk' },
        { url: 'images/BasieReunion.jpeg', title: 'Alt text tk' },
        { url: 'images/Lockjaw.jpg', title: 'Alt text tk' }
      ],
      texts: [
        { content: <>
        <p>It's rare to find album covers featuring multiple musicians, though you do see it in about 9% of those featuring photographs.</p>
        <p>As critics Jon Panish and Carissa Kowalski Dougherty have pointed out, white label executives and white listeners tended to romanticize the individual jazz musician, an innovator venturing alone into uncharted territory. Black listeners, on the other hand, were more likely to identify musicians as members of a community and their playing styles as part of a lineage.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/mcLeanLightsOut.jpg', title: 'Alt text tk', className: 'large-image'}
      ],
      texts: [
        { content: <>
        <p>During this era, album covers remained largely apolitical. Despite the dominant representation of Black musicians on jazz labels' rosters, label executives were likely afraid of alienating white listeners with politicized material.</p>
        <p>But one designer did break new ground in representing the musicians with more humanity than had been done before. And that was Esmond Edwards.</p>
        <p>A passionate photographer, Edwards had grown up in Harlem and was friends with New York-based musicians like drummer Art Taylor, who brought Edwards along to a recording session.</p>
        <p>Edwards made an impression with his session photos. His first cover for Prestige, from that recording session, was Jackie McLean's <em>Lights Out</em> (1956). Weinstock was smart to hire Edwards, whose use of elements like light and shadow brought the label's covers to a new level.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/ColtraneEdwards.jpg', title: 'Alt text tk', className: 'large-image' }
      ],
      texts: [
        { content: <>
        <p>One of Edwards' best-known covers was John Coltrane’s <em>Coltrane</em> (1957). That record was Coltrane's first as a bandleader, and the cover depicted an artist in full control of his talents.</p>
        <p>Edwards once told historian Benjamin Cawthra, “One of the occasional traits in my work was direct eye contact between the subject and the camera. I had a problem with the 'horn-in-mouth' type of pictures, even though sometimes that was the only way to go." Edwards sought to create a "picture of an individual rather than a player of an instrument."</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/Coltrane2.jpg', title: 'Alt text tk' },
        { url: 'images/Dorham.jpg', title: 'Alt text tk' },
        { url: 'images/HawkinsEdwards.jpg', title: 'Alt text tk' }
      ],
      texts: [
        { content: <>
        <p>Edwards' covers show a deep connection with the artists and the environment around him, which make the records shine with an unparalleled sense of intimacy and honesty.</p>
        <p>And even when the covers were not explicitly political, the way Edwards brought Black artists' vulnerability and emotional range to the fore was very much a political act.</p>
        <p>After leaving Prestige in 1962, Edwards would continue to blaze new trails, eventually heading up MGM’s Verve label — along the way becoming one of the first Black recording executives in the industry.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/DolphyJennings1.jpg', title: 'Alt text tk', className: 'large-image' }
      ],
      texts: [
        { content: <>
        <p>Another unique contribution to the history of Prestige's covers — and album cover art more generally — came from Richard "Prophet” Jennings, who painted the covers for Eric Dolphy’s first two records, <em>Outward Bound</em> and <em>Out There</em>.</p>
        <p>The elaborate, surreal designs helped place Dolphy in an otherworldly setting, establishing him as the truly original artist he was.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
        { url: 'images/DolphyJennings2.jpg', title: 'Alt text tk', className: 'large-image'}
      ],
      texts: [
        { content: <>
        <p>We are lucky we can point at a record like Dolphy's <em>Out There</em> and know it was Prophet Jennings, who was known around the industry for his sage advice, who painted it.</p>
        <p>We couldn't do the same for most albums from this time. One historian estimates that the names of the cover designers for over half the records produced from 1948 to 1960 will be forever lost to history.</p>
        <p>By my own count, 56%, or 246, of the Prestige albums I examined do not have publicly available attributions for the cover artist or designer.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [    
        { url: 'images/MosaicPixelated.png', title: 'Alt text tk', className: 'large-image' }
      ],
      texts: [
        { content: <>
        <p>To help preserve and fill out that cultural memory, you can <a href='https://docs.google.com/spreadsheets/d/1iJZIT-hKeO2jBXmd4ByOIGbbY7zshZ_w3qV4CVZq78U/edit?usp=sharing'>find all 438 albums used in this analysis, along with details about who worked on them, here</a>.</p>
        <p>The work is very much incomplete. If you know more about who designed, photographed, or illustrated these covers, you can help fill in the historical record.</p>
        </>, top: 10, left: 10 }
      ]
    },
    {
      images: [
      ],
      texts: [
        { 
          content: <>
              <p className="title-text" id="about-section">About</p>
              <p>Styling Jazz tells a story of mid-century jazz aesthetics through the lens of Prestige Records' cover designs. The analysis, writing, and site design was completed by Alex Lee, a graduate student in the Digital Humanities program at CUNY Graduate Center.</p>
              <p>However, the narrative and analysis builds on extensive historical research conducted by others, including (but not limited to) Benjamin Cawthra, Jon Panish, Carissa Kowalski Dougherty, and Burton Peretti. And the project owes its existence to online music archives and discography trackers like JazzLists, Discogs, Birka Jazz, and JazzDisco.</p>
              <p>You can find out more about the data behind the project <a href='https://docs.google.com/spreadsheets/d/1iJZIT-hKeO2jBXmd4ByOIGbbY7zshZ_w3qV4CVZq78U/edit?usp=sharing'>here</a>.</p>
          </>, 
          top: 0,
          left: 0, 
          style: { 
              background: 'white', 
              color: 'black', 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              width: '50%'
          } 
      },
      ]
    }
    // ... more screens
  ];

  return (
    <div className="app">
      <div className="screens">
        {screens.map((screen, index) => (
          <div key={index} className="screen-component">
            <Screen
              id={`screen-${index}`} // Unique ID for each screen
              images={screen.images}
              texts={screen.texts}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default App;
